export const TARGET_SELECTOR_LABEL_SEPARATOR = ' · ';

export function formatTargetSelectorLabel({
  primaryLabel,
  secondaryLabel,
}: {
  primaryLabel: string;
  secondaryLabel?: string;
}): string {
  return secondaryLabel
    ? `${primaryLabel}${TARGET_SELECTOR_LABEL_SEPARATOR}${secondaryLabel}`
    : primaryLabel;
}
